import { ListRowSkeleton } from "@/components/ui/list-row-skeleton";
import { Skeleton } from "@/components/ui/skeleton";
import type { ProfileBuzzFilter } from "@/lib/profile-navigation";

/** Fits the profile's full mobile column and its narrower desktop content pane. */
export function ProfileBuzzSkeleton({ view }: { view: ProfileBuzzFilter }) {
  if (view === "stats")
    return <ListRowSkeleton rowCount={4} className="py-2" />;
  if (view === "media") {
    return (
      <div
        className="grid grid-cols-3 gap-0.5"
        role="status"
        aria-label="Loading media"
        aria-busy="true"
      >
        {[1, 2, 3, 4, 5, 6].map((id) => (
          <Skeleton key={id} className="aspect-square w-full rounded-none" />
        ))}
      </div>
    );
  }
  return (
    <div
      className="divide-y divide-border"
      role="status"
      aria-label="Loading Buzz"
      aria-busy="true"
    >
      {[1, 2, 3].map((id) => (
        <div key={id} className="space-y-3 px-3 py-3">
          <div className="flex items-center gap-2.5">
            <Skeleton className="size-9 shrink-0 rounded-[11px]" />
            <div className="min-w-0 flex-1 space-y-1.5">
              <Skeleton className="h-3.5 w-28 max-w-full" />
              <Skeleton className="h-2.5 w-20 max-w-full" />
            </div>
          </div>
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-2/3" />
          {view !== "replies" && (
            <Skeleton className="h-40 w-full rounded-2xl" />
          )}
          <div className="flex h-11 items-center justify-around">
            {[1, 2, 3, 4, 5].map((action) => (
              <Skeleton key={action} className="size-5" />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
